import React from "react";
import styled from "styled-components";
import ReactPlayer from "react-player";

export const VideoPlayer = ({
  play = false,
  path,
  loop = false,
  mute = false,
  isBackground = false,
  onEnded,
  thumbnail,
}) => {
  const handleEnd = () => {
    !!onEnded && onEnded();
  };

  const options = {
    controls: !isBackground,
    disablekb: isBackground ? 1 : 0,
    loop: loop,
    muted: mute,
    playing: play,
    url: path,
    volume: mute ? 0 : 1,
    width: "100%",
    height: "100%",
    playsinline: isBackground ? true : false,
    config: {
      file: {
        hlsVersion: "0.14.17",
        hlsOptions: {
          maxMaxBufferLength: 10,
        },
        attributes: {
          // <video> element attributes
          poster: thumbnail ?? null,
          alt:
            "Chase Rice performing on stage, Chase Rice having fun playing games with friends, video cuts from Summerfest showing people enjoying the festival",
        },
      },
    },
    onEnded: handleEnd,
  };

  return <StyledReactPlayer {...options} />;
};

const StyledReactPlayer = styled(ReactPlayer)`
  video {
    outline: none;
    object-fit: cover;
  }
`;
